import { QStaticText } from "../CoreApp/QStaticText";
import { Globals } from "../CoreApp/Globals";

export function AddStaticText(panel, xPos, yPos, label, bold, textColor) {
  var st = new QStaticText();
  st.InitStaticText();
  st.SetLabel(label);
  st.SetBold(bold);
  st.AutoSize();
  st.SetAlignment("left");
  st.PositionElement(xPos, yPos);
  st.SetFontName(Globals._accountInfo.GetAccountFontName());
  if (textColor != null) st.SetTextColor(textColor);
  panel.PushElement(st);

  return st;
}
